import { FormikValues } from 'formik';
import { memoize } from 'lodash';

const DELIVERY_TYPE = {
  ATS: 0,
  EMAIL: 1,
  PHONE: 2,
  EXTERNAL: 3,
};

const calculatedDeliveryType = memoize(
  (values: FormikValues): Array<number> => {
    const deliveryType = [...values.deliveryType];

    if (values.applicationEmail && !values.deliveryType.includes(DELIVERY_TYPE.EXTERNAL)) {
      deliveryType.push(DELIVERY_TYPE.EMAIL);
    }

    if (deliveryType.includes(DELIVERY_TYPE.EMAIL) && !values.applicationEmail) {
      deliveryType.splice(deliveryType.findIndex(item => item === DELIVERY_TYPE.EMAIL), 1);
      deliveryType.push(DELIVERY_TYPE.ATS);
    }

    return deliveryType;
  },
  (values: FormikValues) => {
    return `${values.deliveryType.join('-')}-${values.applicationEmail}-${values.phoneNumber}`;
  }
);

export default DELIVERY_TYPE;
export { calculatedDeliveryType };

